export const isPageBuilderDesignMode = (): boolean => {
  const isIframe = window !== window.parent;
  return !!(window as any).config && isIframe;
};

export const isPreviewMode = (): boolean => {
  return window.location.search.indexOf('preview=1') > -1;
};
